import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { FilePlus2, FolderClosed } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { deleteEmployeeDoc, listEmployeeDocs } from "../../api/employeeDocs";
import { EmployeeDocForm } from "./EmployeeDocForm";
import { EmployeeDocRow } from "./EmployeeDocRow";
import { CardHeader, ToneCard } from "./cardTone";

export const EmployeeDocsCard = ({ userId, canEdit }) => {
  const { t } = useTranslation();
  const [docs, setDocs] = useState([]);
  const [adding, setAdding] = useState(false);

  const load = useCallback(() => {
    listEmployeeDocs(userId).then(setDocs).catch(() => setDocs([]));
  }, [userId]);
  useEffect(load, [load]);

  const remove = async (doc) => {
    await deleteEmployeeDoc(doc.id);
    toast.success(t("empDocs.deleted"));
    load();
  };

  const addBtn = canEdit ? (
    <NeuButton
      variant="primary"
      className="flex items-center gap-2"
      data-testid="emp-doc-add"
      onClick={() => setAdding((v) => !v)}
    >
      <FilePlus2 className="h-4 w-4" /> {t("empDocs.add")}
    </NeuButton>
  ) : null;

  return (
    <ToneCard tone="amber" className="lg:col-span-3" testId="emp-docs-card">
      <CardHeader icon={FolderClosed} tone="amber" title={t("empDocs.title")} hint={t("empDocs.subtitle")} right={addBtn} />
      {adding ? (
        <EmployeeDocForm
          userId={userId}
          onCancel={() => setAdding(false)}
          onSaved={() => { setAdding(false); load(); }}
        />
      ) : null}
      {!docs.length ? (
        <p className="mt-5 text-sm text-muted-foreground" data-testid="emp-docs-empty">{t("empDocs.none")}</p>
      ) : (
        <ul className="mt-4 divide-y divide-border/50" data-testid="emp-docs-list">
          {docs.map((doc) => (
            <EmployeeDocRow key={doc.id} doc={doc} canEdit={canEdit} onDelete={remove} />
          ))}
        </ul>
      )}
    </ToneCard>
  );
};
